import Dropdown from '@lyra/core/components/Dropdown'
import DropdownListItem from '@lyra/core/components/Dropdown/DropdownListItem'
import Icon, { ChevronDown, ChevronUp } from '@lyra/core/components/Icon'
import VideoText from '@lyra/core/components/VideoText'
import useHover from '@lyra/core/hooks/useHover'
import { Ticker } from '@lyra/web/constants/instruments'
import { formatTokenSymbol, getCurrencyId } from '@lyra/web/utils/tokens'
import { useState } from 'react'
import { XStack } from 'tamagui'

type Props = {
  isHighlighted: boolean
  isQuoteCollateralAmount: boolean
  ticker: Ticker
  onChangeIsQuoteCollateral: (isQuoteCollateralAmount: boolean) => void
}

export default function TradeFormCollateralTypeDropdown({
  ticker,
  isHighlighted,
  isQuoteCollateralAmount,
  onChangeIsQuoteCollateral,
}: Props) {
  const [isOpen, setIsOpen] = useState(false)
  const { handleHoverIn, handleHoverOut, isHovering } = useHover()

  const baseCollateralId = getCurrencyId(ticker.base_currency)

  if (!baseCollateralId) {
    return null
  }

  return (
    <Dropdown
      onChangeOpen={setIsOpen}
      trigger={
        <XStack
          gap="$0.5"
          alignItems="center"
          paddingVertical="$0.5"
          cursor="pointer"
          onHoverIn={handleHoverIn}
          onHoverOut={handleHoverOut}
        >
          <VideoText color={isHovering || isHighlighted || isOpen ? 'primary' : 'secondary'}>
            {isQuoteCollateralAmount ? 'USD' : formatTokenSymbol(baseCollateralId)}
          </VideoText>
          <Icon
            size={12}
            icon={isOpen ? <ChevronUp /> : <ChevronDown />}
            color={isHovering ? '$primaryText' : '$secondaryText'}
          />
        </XStack>
      }
    >
      <DropdownListItem
        label={formatTokenSymbol(baseCollateralId)}
        onPress={() => onChangeIsQuoteCollateral(false)}
      />
      <DropdownListItem label="USD" onPress={() => onChangeIsQuoteCollateral(true)} />
    </Dropdown>
  )
}
